/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState} from "react";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import TableHeader from "../../Components/Common/TableHeader";
import Loader from "../../Components/Common/Loader";
import TransactionsTable from "../Common/Transactions/TransactionsTable";
import Pagination from "../Common/Pagination";
import ajaxBank from "../../util/remote/ajaxBank";
import MMTransactionsSearchForm from "../Common/Transactions/MMTransactionsSearchForm";
import CancelMMTransaction from "../Common/Transactions/CancelMMTransaction";
import useStateCallback from "../../util/customHooks/useStateCallback";

function MMTransactions() {
  const [mmTransactions, setMMTransactions] = useState(false);
  const [mmSearchTerm, setMmSearchTerm] = useState("");
  const [mmStartDate, setMmStartDate] = useState("");
  const [mmEndDate, setMmEndDate] = useState("");
  const [type, setType] = useState("");
  const [mmPage,setMmPage] = useState(1)
  const [mmMeta,setMmMeta] = useState([])
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [modal, setModal] = useStateCallback(false);

  const fetchMMTransactions = async (currentPage) => {
      setLoading(true);
      const response = await ajaxBank.fetchMMTransactions(currentPage);
      setLoading(false);
      if (response.status === "OK") {
        setMmMeta(response.details.meta.totalPages);
        setMMTransactions(response.details.data || []);
      } else {
        setMMTransactions([]);
      }
  };

  const searchMMTransactions = async (e) => {
      if (e) e.preventDefault();
      setLoading2(true);
  
      const response = await ajaxBank.searchMMTransactions(mmPage, mmStartDate, mmEndDate, mmSearchTerm, type);
      setLoading2(false);
  
      if (response.status === "OK") {
        setMmMeta(response.details.meta.totalPages);
        setMMTransactions(response.details.data || []);
      } else {
        setMMTransactions([]);
      }
    };


  const resetFilters = (e) => {
    e.preventDefault();
    setMmSearchTerm("");
    setMmStartDate("");
    setMmEndDate("");
    setType("");
    setMmPage(1);
    fetchMMTransactions(1);
  };

  const cancelTransaction = (e, item) => {
      setModal(false, () =>
        setModal(
          <CancelMMTransaction
            transID={item.mm_payment_id}
            g={fetchMMTransactions}
            page={mmPage}
            isOpen={true}
          />
        )
      );
  };

  const exportToPDF = () => {
    const pdf = new jsPDF("p", "pt", "a4");
    const columns = ["Date & Time", "User", "Transaction Number", "Amount"];
    const data = mmTransactions.map(item => [
      `${item.created_at?.short_date} ${item.created_at?.time}`,
      `${item.user} (${item.username})`,
      item.phone_number,
      `UGX. ${item.amount}`,
    ]);

    pdf.autoTable({ head: [columns], body: data });
    pdf.save("mm_data.pdf");
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= mmMeta) {
      setMmPage(newPage);
    }
  };

  const headers = [
    { label: "Transaction Date", key: "created_at" },
    { label: "User Details", key: "student" },
    { label: "Transaction Number", key: "phone_number" },
    { label: "Amount", key: "amount" },
    { label: "Transaction Type", key:"account"},
    // { label: "Client Ref", key:"internal_ref"},
    { label: "Actions", key:"actions"}

  ];

  useEffect(() => {
    if (mmSearchTerm || mmStartDate || mmEndDate || type) {
      searchMMTransactions();
    } else {
      fetchMMTransactions(mmPage);
    }
  }, [mmPage]);

  return (
    <>
    {modal}
      <div className="heading-layout1 mg-b-5">
        <TableHeader
          title="Mobile Money Transactions"
         subtitle="List of all the mobile money transactions made sorted by the most recent" />
        <div className="dropdown">
          <Link className="dropdown-toggle" role="button" data-toggle="dropdown">...</Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" onClick={exportToPDF}>
              <i className="fas fa-file-export"></i>Export
            </Link>
          </div>
        </div>
      </div>

      
      <MMTransactionsSearchForm searchTerm={mmSearchTerm} type={type} setSearchTerm={setMmSearchTerm} setType={setType} startDate={mmStartDate}
         setStartDate={setMmStartDate} endDate={mmEndDate} setEndDate={setMmEndDate} searchTransactions={searchMMTransactions}
         resetSearch={resetFilters} setPage={setMmPage}/>
      <div className="border-top mt-3"></div>
      <div className="table-responsive">
        {loading || loading2 ? (
          <Loader />
        ) : (
          <TransactionsTable headers={headers} data={mmTransactions} isMMTransaction={true} cancelTransaction={cancelTransaction}/>
        )}
      </div>

      <Pagination currentPage={mmPage} totalPages={mmMeta} onPageChange={handlePagination}/>

    </>
  );
}

export default MMTransactions;